import React from 'react';

import { Box, Flex, Group, ScrollArea, Text, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { ChatMessage } from 'shared/interfaces/ChatMessage';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';
import { formatSecondsToTranscriptTimestamp } from 'shared/utils/format';

interface TranscriptTabProps {
  messages: ChatMessage[];
  smartAssistant: SmartAssistant;
}

export function TranscriptTab({ messages, smartAssistant }: TranscriptTabProps) {
  const { t } = useTranslation();
  const searchForm = useForm({ initialValues: { searchQuery: '' } });

  const filteredMessages = messages.filter((message) =>
    message.text.toLowerCase().includes(searchForm.values.searchQuery.toLowerCase())
  );

  const getMessageTimestamp = (message: ChatMessage) => {
    if (!message.secondsFromStart) return '';
    return formatSecondsToTranscriptTimestamp(message.secondsFromStart);
  };

  return (
    <Flex direction="column" h="100%">
      <TextInput
        icon={<IconSearch />}
        placeholder={t('SMART_ASSISTANT.VOICE_CALLS_SECTION.TRANSCRIPT_TAB.SEARCH_PLACEHOLDER')}
        mb="md"
        {...searchForm.getInputProps('searchQuery')}
      />
      <ScrollArea style={{ flex: 1 }} type="never">
        {filteredMessages.map((message, messageIndex) => (
          <Box key={messageIndex} mb="md" p="xs">
            <Group position="apart" noWrap>
              <Text size="md" weight={500} lineClamp={1}>
                {message.fromUser
                  ? t('SMART_ASSISTANT.VOICE_CALLS_SECTION.TRANSCRIPT_TAB.CALLER')
                  : smartAssistant.name}
              </Text>
              <Text size="sm" color="dimmed">
                {getMessageTimestamp(message)}
              </Text>
            </Group>
            <Text size="sm" mt="xs" mr={50}>
              {message.text}
            </Text>
          </Box>
        ))}
      </ScrollArea>
    </Flex>
  );
}
